export default __webpack_public_path__ + "static/media/fluentsmartexam.4f141093.png";